import { setLocale } from 'yup';

export const FIELD_REQUIRED_MSG = 'Field is required';
export const INVALID_EMAIL_MSG =
  'Invalid email address. Please check your email and  try again. Your email must follow the format abc@123.com.';

export const config = () => {
  setLocale({
    mixed: {
      required: fieldInfo => {
        return (
          FIELD_REQUIRED_MSG +
          '. Missing property: ' +
          fieldInfo.path +
          '. Full field info: ' +
          JSON.stringify(fieldInfo)
        );
      },
    },
    string: {
      email: INVALID_EMAIL_MSG,
    },
  });
};
